import axiosInstance from "..";

export async function getAppointments() {
  try {
    const response = await axiosInstance.get("/appointment/patient");
    if (response.status === 200) {
      return response.data?.data;
    } else throw new Error("Could not get Appointments", response);
  } catch (err) {
    console.log(err);
  }
}

export async function getTimeSlots(clinicId) {
  try {
    const response = await axiosInstance.get(`get/slots?clinicId=${clinicId}`);
    if (response.status === 200) {
      return response.data;
    } else throw new Error("Could not get Slots", response);
  } catch (err) {
    console.log(err);
  }
}

export async function createAppointmentForSelf(details) {
  try {
    const response = await axiosInstance.post(
      "/appointment/patient/self",
      details,
    );
    if (response) {
      return response;
    } else throw new Error("Could not get Slots", response);
  } catch (err) {
    console.log(err);
    return err.response;
  }
}

export async function createAppointmentForSomeone(details) {
  try {
    const response = await axiosInstance.post(
      "/appointment/patient/someone",
      details,
    );
    if (response) {
      return response;
    } else throw new Error("Could not get Slots", response);
  } catch (err) {
    console.log(err);
    return err.response;
  }
}

export async function cancelAppointment(appointmentId) {
  try {
    const response = await axiosInstance.patch("/appointment/cancel", {
      appointmentId,
    });
    if (response) {
      return response;
    } else throw new Error("Error cancelling appointment", response);
  } catch (err) {
    console.log(err);
    return err.response;
  }
}

export async function startVideoConsultation(appointmentId, payload = {}) {
  try {
    const response = await axiosInstance.post(
      `/appointment/${appointmentId}/video-consultation/start`,
      payload,
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
}

export async function joinVideoConsultation(appointmentId) {
  try {
    const response = await axiosInstance.post(
      `/appointment/${appointmentId}/video-consultation/join`,
    );
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
}
